<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-format-align-justify</v-icon>
        <v-toolbar-title>Bordereaux Item</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2" @click="doAddPolBordItem">
          Add Item
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-btn flat icon @click="doClose()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12 class="mt-2">
                  <template>
                    <v-data-table
                      :headers="headers"
                      :items="items"
                      :search="search"
                      :footer-props="{ 'items-per-page-options': itemsPerPage }"
                      :options.sync="pagination"
                      :loading="loading"
                      item-key="name"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row">
                        <tr>
                          <td>{{ row.item.bordItemNo }}</td>
                          <td>{{ row.item.cedPolNo }}</td>
                          <td>{{ row.item.comDateFormat }}</td>
                          <td>{{ row.item.expDateFormat }}</td>
                          <td>{{ row.item.si }}</td>
                          <td>{{ row.item.gap }}</td>
                          <td>{{ row.item.premDue }}</td>
                          <td>{{ row.item.comm }}</td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              review
                              @review="doSetPolBordItem(row.item)"
                              remove
                              @remove="doPromptPolBordItem(row.item)"
                            ></table-action>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                    <confirm v-model="promptRemovePolBordItem" @ok="doRemovePolBordItem">{{ deletePolBordItem }}</confirm>
                  </template>
                </v-flex>
                <v-flex xs12 v-if="polBordItemForm.bordItemNo !== undefined">
                  <v-card>
                    <v-toolbar dense color="grey lighten-3" flat>
                      <v-icon>mdi-pencil</v-icon>
                      <v-toolbar-title class="toolbar-title-3">{{ labels.PolBordItemDetails }}</v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex lg6 md6 sm6 xs12>
                            <v-text-field v-model="polBordItemForm.bordItemNo" :label="labels.bordItemNo" :disabled="true"></v-text-field>
                          </v-flex>
                          <v-flex lg6 md6 sm6 xs12>
                            <v-text-field
                              v-model="polBordItemForm.cedPolNo"
                              :label="labels.cedPolNo"
                              :error-messages="errors.collect('cedPolNo')"
                              data-vv-name="cedPolNo"
                              :data-vv-as="labels.cedPolNo"
                              v-validate="'required|max:20'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg6 md6 sm6 xs12>
                            <cal-picker v-model="polBordItemForm.comDate" :label="labels.comDate"></cal-picker>
                          </v-flex>
                          <v-flex lg6 md6 sm6 xs12>
                            <cal-picker v-model="polBordItemForm.expDate" :label="labels.expDate"></cal-picker>
                          </v-flex>
                          <v-flex lg6 md6 sm6 xs12>
                            <v-text-field
                              type="number"
                              v-model="polBordItemForm.contrctMp"
                              :label="labels.contrctMp"
                              :error-messages="errors.collect('contrctMp')"
                              data-vv-name="contrctMp"
                              :data-vv-as="labels.contrctMp"
                              v-validate="'required|mask_decimal:0|mask_min_value:0'"
                              min="0"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg6 md6 sm6 xs12>
                            <cal-picker v-model="polBordItemForm.contrctExpDate" :label="labels.contrctExpDate"></cal-picker>
                          </v-flex>
                          <v-flex lg12 md12 sm12 xs12>
                            <v-text-field
                              v-model="polBordItemForm.name1"
                              :label="labels.name1"
                              :error-messages="errors.collect('name1')"
                              data-vv-name="name1"
                              :data-vv-as="labels.name1"
                              v-validate="'max:30'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg6 md6 sm6 xs12>
                            <v-text-field
                              ref="si"
                              v-model="polBordItemForm.si"
                              :label="labels.si"
                              :error-messages="errors.collect('si')"
                              data-vv-name="si"
                              :data-vv-as="labels.si"
                              v-num-mask="{ negative: true, intScale: 16, decScale: 2 }"
                              @change="doCalc"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg6 md6 sm6 xs12> </v-flex>
                          <v-flex lg6 md6 sm6 xs12>
                            <v-text-field
                              ref="premRatePct"
                              v-model="polBordItemForm.premRatePct"
                              :label="labels.premRatePct"
                              :error-messages="errors.collect('premRatePct')"
                              data-vv-name="premRatePct"
                              :data-vv-as="labels.premRatePct"
                              v-num-mask="{ negative: true, intScale: 12, decScale: 6 }"
                              @change="doCalc"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg6 md6 sm6 xs12>
                            <v-text-field
                              ref="commPct"
                              v-model="polBordItemForm.commPct"
                              :label="labels.commPct"
                              :error-messages="errors.collect('commPct')"
                              data-vv-name="commPct"
                              :data-vv-as="labels.commPct"
                              v-num-mask="{ negative: true, intScale: 12, decScale: 6 }"
                              @change="doCalc"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg6 md6 sm6 xs12>
                            <v-layout row wrap>
                              <v-checkbox v-model="polBordItemForm.gapAe" hide-details class="shrink mr-2" :label="labels.gapAe" @change="doCalc" />
                              <v-text-field
                                ref="gap"
                                v-model="polBordItemForm.gap"
                                :label="labels.gap"
                                :error-messages="errors.collect('gap')"
                                data-vv-name="gap"
                                :data-vv-as="labels.gap"
                                v-num-mask="{ negative: true, intScale: 16, decScale: 2 }"
                                :disabled="polBordItemForm.gapAe"
                                @change="doCalc"
                              ></v-text-field>
                              <span style="width: 5px" />
                            </v-layout>
                          </v-flex>
                          <v-flex lg6 md6 sm6 xs12>
                            <v-layout row wrap>
                              <v-checkbox v-model="polBordItemForm.commAe" hide-details class="shrink mr-2" :label="labels.commAe" @change="doCalc" />
                              <v-text-field
                                ref="comm"
                                v-model="polBordItemForm.comm"
                                :label="labels.comm"
                                :error-messages="errors.collect('comm')"
                                data-vv-name="comm"
                                :data-vv-as="labels.comm"
                                v-num-mask="{ negative: true, intScale: 16, decScale: 2 }"
                                :disabled="polBordItemForm.commAe"
                                @change="doCalc"
                              ></v-text-field>
                              <span style="width: 5px" />
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md2 sm2 xs12>
                            <v-autocomplete
                              :items="aepList"
                              :label="labels.premDueAep"
                              v-model="polBordItemForm.premDueAep"
                              item-text="label"
                              item-value="value"
                              @change="doCalc"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex lg4 md4 sm4 xs12>
                            <v-text-field
                              ref="premDue"
                              v-model="polBordItemForm.premDue"
                              :label="labels.premDue"
                              :error-messages="errors.collect('premDue')"
                              data-vv-name="premDue"
                              :data-vv-as="labels.premDue"
                              v-num-mask="{ negative: true, intScale: 16, decScale: 2 }"
                              :disabled="disablePd"
                              @change="doCalc"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg6 md6 sm6 xs12> </v-flex>
                          <v-flex xs12>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn depressed @click="doClose"><span class="btn-normal-error">Close</span></v-btn>
                              <v-btn depressed @click="doSave"><span class="btn-normal-primary">Save</span></v-btn>
                            </v-card-actions>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>

    <v-dialog v-model="saving" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatPrice } from '@/utils/index'
import { formatDisplayDate } from '@/utils/date'
import { removeFormatNumber } from '@/utils/number'

export default {
  data() {
    return {
      headers: [
        { text: 'Item', value: 'bordItemNo' },
        { text: 'Ref No.', value: 'cedPolNo' },
        { text: 'Commence Date', value: 'comDate' },
        { text: 'Expiry Date', value: 'expDate' },
        { text: 'SI', value: 'si' },
        { text: 'GAP', value: 'gap' },
        { text: 'Prem Due', value: 'premDue' },
        { text: 'Commission', value: 'comm' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      loading: false,
      items: [],
      selectedPolBordItem: undefined,
      deletePolBordItem: undefined,
      promptRemovePolBordItem: undefined,
      labels: {
        PolBordItemDetails: 'Bordereaux Item Details',
        bordItemNo: 'Item No.',
        cedPolNo: 'Reference No.',
        comDate: 'Commence Date',
        expDate: 'Expiry Date',
        si: 'Sum Insured',
        premRatePct: 'Premium Rate%',
        gap: 'GAP',
        premDueAep: 'Premium A/E/P',
        premDue: 'Premium Due',
        commPctAe: undefined,
        commPct: 'Commission Rate%',
        comm: 'Commission',
        contrctMp: 'Contract Maintenance Period (Months)',
        contrctExpDate: 'Contract Expiry Date',
        name1: 'Insured Name'
      },
      polBordItemForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        bordItemNo: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        comDate: undefined,
        expDate: undefined,
        cedPolNo: undefined,
        si: undefined,
        premRatePct: undefined,
        gapAe: undefined,
        gap: undefined,
        premDueAep: undefined,
        premDue: undefined,
        commPctAe: undefined,
        commPct: undefined,
        commAe: undefined,
        comm: undefined,
        contrctMp: undefined,
        contrctExpDate: undefined,
        name1: undefined
      },
      saving: false,
      polBordItemSave: undefined
    }
  },
  props: {
    polItem: Object
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      const apiUrl = this.menu.polBordItemList
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.polItem.riskGrpNo,
            riskNo: this.polItem.riskNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          this.displayPolBordItemList(result).then(() => {
            this.loading = false
            if (this.items.length > 0 && this.polBordItemForm.bordItemNo === undefined) {
              this.doSetPolBordItem(this.items[0])
            }
          })
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error(this.invalidAPIUrlMessage())
      }
    },
    async displayPolBordItemList(result) {
      const { data } = result.data
      if (data) {
        this.items = []
        data.map((polBordItem) => {
          const polBordItemList = {
            polNo: polBordItem.polNo,
            renCnt: polBordItem.renCnt,
            endtCnt: polBordItem.endtCnt,
            bordItemNo: polBordItem.bordItemNo,
            riskGrpNo: polBordItem.riskGrpNo,
            riskNo: polBordItem.riskNo,
            comDateFormat: formatDisplayDate(polBordItem.comDate),
            expDateFormat: formatDisplayDate(polBordItem.expDate),
            comDate: polBordItem.comDate,
            expDate: polBordItem.expDate,
            cedPolNo: polBordItem.cedPolNo,
            si: formatPrice(polBordItem.si),
            premRatePct: formatPrice(polBordItem.premRatePct),
            gapAe: polBordItem.gapAe,
            gap: formatPrice(polBordItem.gap),
            premDueAep: polBordItem.premDueAep,
            premDue: formatPrice(polBordItem.premDue),
            commPctAe: polBordItem.commPctAe,
            commPct: formatPrice(polBordItem.commPct),
            commAe: polBordItem.commAe,
            comm: formatPrice(polBordItem.comm),
            contrctMp: polBordItem.contrctMp,
            contrctExpDate: polBordItem.contrctExpDate,
            name1: polBordItem.name1,
            newRec: polBordItem.newRec
          }
          this.items.push(polBordItemList)
        })
      } else {
        this.items = []
      }
      return true
    },
    async doAddPolBordItem() {
      const apiUrl = this.menu.addPolBordItem
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            riskGrpNo: this.polItem.riskGrpNo,
            riskNo: this.polItem.riskNo
          }

          const result = await this.$http.get(expandURI(apiUrl, expand))

          this.displayPolBordItemList(result).then(() => {
            this.loading = false
            this.doSetPolBordItem(this.getNewPolBordItem[0])
          })
          this.$toast.success('New Bordereaux Item sucessfully added.')
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error(this.invalidAPIUrlMessage())
      }
    },
    doSetPolBordItem(data) {
      this.polBordItemForm.polNo = data.polNo
      this.polBordItemForm.renCnt = data.renCnt
      this.polBordItemForm.endtCnt = data.endtCnt
      this.polBordItemForm.bordItemNo = data.bordItemNo
      this.polBordItemForm.riskGrpNo = data.riskGrpNo
      this.polBordItemForm.riskNo = data.riskNo
      this.polBordItemForm.comDate = data.comDate
      this.polBordItemForm.expDate = data.expDate
      this.polBordItemForm.cedPolNo = data.cedPolNo
      this.polBordItemForm.si = data.si
      this.polBordItemForm.premRatePct = data.premRatePct
      this.polBordItemForm.gapAe = data.gapAe
      this.polBordItemForm.gap = data.gap
      this.polBordItemForm.premDueAep = data.premDueAep
      this.polBordItemForm.premDue = data.premDue
      this.polBordItemForm.commPctAe = data.commPctAe
      this.polBordItemForm.commPct = data.commPct
      this.polBordItemForm.commAe = data.commAe
      this.polBordItemForm.comm = data.comm
      this.polBordItemForm.contrctMp = data.contrctMp
      this.polBordItemForm.contrctExpDate = data.contrctExpDate
      this.polBordItemForm.name1 = data.name1
    },
    invalidAPIUrlMessage() {
      return 'The request failed because it is trying to execute an invalid API url.'
    },
    doPromptPolBordItem(data) {
      this.selectedPolBordItem = data
      this.deletePolBordItem = 'Are you sure you want to delete Item no. ' + data.bordItemNo + '?'
      this.promptRemovePolBordItem = true
    },
    async doRemovePolBordItem() {
      const apiUrl = this.menu.delPolBordItem
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.selectedPolBordItem.polNo,
            renCnt: this.selectedPolBordItem.renCnt,
            endtCnt: this.selectedPolBordItem.endtCnt,
            riskGrpNo: this.selectedPolBordItem.riskGrpNo,
            riskNo: this.selectedPolBordItem.riskNo,
            bordItemNo: this.selectedPolBordItem.bordItemNo
          }

          const result = await this.$http.get(expandURI(apiUrl, expand))

          this.displayPolBordItemList(result).then(() => {
            this.loading = false
            if (this.items.length > 0) {
              this.doSetPolBordItem(this.items[0])
            }
          })
          this.$toast.success('New Bordereaux Item sucessfully added.')
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error(this.invalidAPIUrlMessage())
      }
    },
    doClose() {
      this.$emit('close')
      // this.resetMessages()
      // this.$validator.validateAll().then(result => {
      //   if (result) {
      //     this.$emit('close')
      //   } else {
      //     this.promptFieldCheck()
      //   }
      // })
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saving = true

          // Temporary
          this.polBordItemSave = this.polBordItemForm
          this.polBordItemSave.si = removeFormatNumber(this.polBordItemSave.si)
          this.polBordItemSave.premRatePct = removeFormatNumber(this.polBordItemSave.premRatePct)
          this.polBordItemSave.gap = removeFormatNumber(this.polBordItemSave.gap)
          this.polBordItemSave.premDue = removeFormatNumber(this.polBordItemSave.premDue)
          this.polBordItemSave.commPct = removeFormatNumber(this.polBordItemSave.commPct)
          this.polBordItemSave.comm = removeFormatNumber(this.polBordItemSave.comm)
          this.$store.dispatch('savePolBordItem', this.polBordItemSave).then((success) => {
            if (success) {
              this.$toast.success('Bordereaux Item Successfully Saved')
              this.saving = false
              this.doInit()
            } else {
              this.saving = false
              this.$toast.error('Bordereaux Item Save Failed')
            }
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCalc() {
      if (this.polBordItemForm.gapAe === true) {
        this.polBordItemForm.gap = formatPrice(
          (parseFloat(removeFormatNumber(this.polBordItemForm.si)) * parseFloat(removeFormatNumber(this.polBordItemForm.premRatePct))) / 100
        )
      }
      if (this.polBordItemForm.premDueAep === 'A') {
        await this.getPremDue()
      }
      if (this.polBordItemForm.commAe === true) {
        this.polBordItemForm.comm = formatPrice(
          (parseFloat(removeFormatNumber(this.polBordItemForm.premDue)) * parseFloat(removeFormatNumber(this.polBordItemForm.commPct))) / 100
        )
      }
    },
    async getPremDue() {
      const apiUrl = this.menu.getPolBordItemPremDue
      if (apiUrl) {
        try {
          const expand = {
            polNo: this.polBordItemForm.polNo,
            renCnt: this.polBordItemForm.renCnt,
            endtCnt: this.polBordItemForm.endtCnt,
            riskGrpNo: this.polBordItemForm.riskGrpNo,
            riskNo: this.polBordItemForm.riskNo,
            bordItemNo: this.polBordItemForm.bordItemNo,
            comDate: new Date(this.polBordItemForm.comDate),
            expDate: new Date(this.polBordItemForm.expDate),
            gap: removeFormatNumber(this.polBordItemForm.gap)
          }

          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            this.polBordItemForm.premDue = formatPrice(result.data.data)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error(this.invalidAPIUrlMessage())
      }
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    menu() {
      return this.$store.state.underwriting.policyRiskItemSettings.menu
    },
    getNewPolBordItem() {
      return this.items.filter((item) => {
        return item.newRec === true
      })
    },
    aepList() {
      return [
        { label: 'A', value: 'A' },
        { label: 'E', value: 'E' },
        { label: 'P', value: 'P' }
      ]
    },
    disablePd() {
      return this.polBordItemForm.premDueAep === 'A'
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
